import ApiHelper from '@/services/ApiHelper';
import StaticPageModel from '@/models/StaticPageModel';
import { toastController, ToastOptions } from '@ionic/vue';

export const menuActionScroller = (weaken = 1) => {
    const actionScroll = document.getElementById('actionColScroll');
    setTimeout(() => {
        actionScroll?.scrollTo({
            top: actionScroll?.scrollHeight / weaken,
            behavior: 'smooth',
        });
    }, 100);
};
export const pageAccessedByReload =
    (window.performance.navigation && window.performance.navigation.type === 1) ||
    window.performance
        .getEntriesByType('navigation')
        //@ts-ignore
        .map((nav) => nav.type)
        .includes('reload');

export const errorToast = async (errorMessage: string, duration = 3000) => {
    await toastController
        .create({
            message: errorMessage,
            duration: duration,
            color: 'primary',
            position: 'top',
            cssClass: 'ion-text-center pa-4',
        })
        .then((t) => t.present());
};
export const successToast = async (successMessage: string) => {
    return await toastController
        .create({
            message: successMessage,
            duration: 4000,
            color: 'success',
            position: 'top',
            cssClass: 'ion-text-center  pa-4',
        })
        .then((t) => t.present());
};
export const successToastDetail = async (options: ToastOptions) => {
    return await toastController
        .create({
            message: options.message,
            duration: options.duration ?? 4000,
            color: options.color ?? 'primary',
            position: options.position,
            cssClass: 'ion-text-center ion-padding ' + options?.cssClass ?? '',
        })
        .then((t) => t.present());
};

export const vanillaQueryParam = (queryParam: string) => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop as string),
    });
    return params[queryParam];
};

/** API */

export const fetchPage = async (uri: string): Promise<StaticPageModel[]> => ApiHelper.get(`/page?uri=${uri}`);
